import { useEffect, useState } from "react";
import { Button } from "../ui/Button"
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import clsx from "clsx";
import { RadioGroup, RadioGroupItem } from "../ui/Radio";
import { LeftArrow, RightArrow } from "../../icons";

const currentYear = new Date().getFullYear();
const yearsList = Array.from({ length: 101 }, (_, index) => currentYear - index);
const monthsList = [
    'Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάϊος', 'Ιούνιος',
    'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'
];

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    mobile: {
        breakpoint: { max: 1024, min: 100 },
        items: 3
    }
  };

export const CalendarContent = ({onDismiss, onApply, value,onSortingClick,sortValue}) => {
    const [activeYear, setActiveYear] = useState(0);
    const [activeMonth, setActiveMonth] = useState(1)

    useEffect(() => {
        if (value.year) {
            setActiveYear(yearsList.findIndex(year=> year === value.year))
        }
        if (value.month) {
            setActiveMonth(value.month)
        }
    }, [value])

    const CustomButtonGroup = ({ next, previous, ...rest }) => {
        const { carouselState } = rest;
        return (
              <div className="w-full lg:min-w-[650px] items-center justify-between flex absolute top-[15px] max-lg:-left-[15px] lg:-left-[20px]">
                  <div
                  className={clsx("h-10 w-10 bg-white flex items-center justify-center", carouselState.currentSlide === 0 ? 'opacity-40' : 'cursor-pointer')}
                  onClick={() => carouselState.currentSlide !== 0 && previous()}
                >
                  <LeftArrow />
                </div>
                  <div
                    className={clsx("h-10 w-10 bg-white flex items-center justify-center", carouselState.currentSlide === carouselState.totalItems - 1 ? 'opacity-40' : ' cursor-pointer')}
                    onClick={() => carouselState.currentSlide !== carouselState.totalItems - 1 && next()}
                  >
                    <RightArrow />
                  </div>
              </div>
        );
      };


    return (
        <div className="flex flex-col lg:items-center lg:pt-10 overflow-auto justify-between h-full max-lg:pb-[160px]"> 
            <div className="flex flex-col  gap-2 lg:px-10 w-full lg:justify-center lg:items-center">
                <h3 className='lg:hidden pb-3'>Φίλτρα</h3>
                <h3 className="pb-3 max-lg:hidden">Επιλογή έτους</h3>
                <h5 className="pb-3 lg:hidden">Επιλογή έτους</h5>
                <div className="p-6 border-t border-b border-[#F5F5F7] w-full max-w-[600px] relative">
                    <Carousel
                        responsive={responsive}
                        infinite={false}
                        keyBoardControl={true}
                        transitionDuration={500}
                        containerClass="w-full z-[1000]"
                        centerMode={true}
                        focusOnSelect
                        beforeChange={(nextSlide, props) => {
                            setActiveYear(nextSlide)
                        }}
                        swipeable
                        arrows={false}
                        renderButtonGroupOutside
                        customButtonGroup={<CustomButtonGroup />}
                    >
                        {yearsList.map((year,index) => <p key={year} className={activeYear === index ?"h4 cursor-pointer" :"text-body-large text-[#6A6A6A] cursor-pointer"}>{year}</p>)}
                    </Carousel>
                </div>
                <div className="flex flex-col lg:items-center lg:py-4">
                    <h5 className="pb-3 lg:h5">Επιλογή μήνα</h5>
                    <div className="flex gap-3 flex-wrap lg:w-7/12 lg:justify-center items-center">
                        {monthsList.map((month, index) =>
                            <Button key={index} onClick={()=>{setActiveMonth(index+1)}} className={clsx(' px-6 py-3 rounded-[8px] text-body-large', index+1 === activeMonth ? 'text-white bg-[#D4002A]': 'border border-[#A5A5A5] text-[#282828]')}>
                                {month}
                            </Button>
                        )}
                    </div>
                </div>
                <h5 className="lg:hidden">Ταξινόμηση</h5>
                <RadioGroup
                    value={sortValue}
                    className="flex flex-col gap-2 lg:hidden"
                    onValueChange={onSortingClick}
                >
                    <div className="flex gap-2">
                        <RadioGroupItem value={true} />
                        <p className="text-body">Νεότερα</p>
                    </div>
                    <div className="flex gap-2">
                        <RadioGroupItem value={false} />
                        <p className="text-body" >Παλαιότερα</p>
                    </div>
                </RadioGroup>
            </div>
            <div
                className="w-full flex max-lg:flex-col-reverse w-full lg:justify-center lg:px-10 lg:pb-10 pt-6 lg:border-t lg:border-[#63636333] gap-3 max-lg:fixed max-lg:pt-6 max-lg:pb-10 max-lg:px-5 max-lg:bottom-0 max-lg:left-0 max-lg:shadow-md max-lg:bg-white max-lg:shadow-[0px_-8px_10px_0px_#0000000D]">
                <Button onClick={onDismiss} className={' border border-[#A5A5A5] lg:px-14 py-3 rounded-[6px] text-primary-button text-[#282828]'}>
                    Ακύρωση
                </Button>
                <Button onClick={()=>{onApply(yearsList[activeYear], activeMonth)}} className={'disabled:bg-[#A5A5A5] bg-[#D4002A] px-14 py-3 rounded-[6px] text-white text-primary-button'}>
                Εφαρμογή
                </Button>
            </div>
        </div>
    )
}